module.exports = __webpack_public_path__ + "img/banner_bg_prize_rank.1662d435.png";